import type * as chartJs from 'chart.js'

export const DEFAULT_OPTIONS: Partial<
  chartJs.CoreChartOptions<keyof chartJs.ChartTypeRegistry>
> = {
  layout: {
    padding: 20,
  },
  maintainAspectRatio: false,
}
